import React from "react";
import { PropertyEditorBoolean, PropertyEditorBooleanInterface } from "../PropertyEditorBoolean";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextData implements PropertyEditorBooleanInterface {
    editObject: object = {};
    hint: string = "hint";
    label: string = "Boolean Editor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

class TextData2 implements PropertyEditorBooleanInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            if (Reflect.get(this, "textValue") === undefined || Reflect.get(this, "textValue") === false)
                return [
                    new ValidationIssue("false not allowed", "textValue"),
                    new ValidationIssue("false not allowed2", "textValue"),
                ];
            return [];
        },
    };
    hint: string = "hint";
    label: string = "Boolean Editor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
    requiredText: string = "required text";
}

let args = new TextData();
let args2 = new TextData2();

export const BooleanPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorBoolean
                    sx={{ width: "200px" }}
                    {...args}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName) + "")}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Boolean",
        "Simple",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorBoolean
                    sx={{ width: "200px" }}
                    error={"error"}
                    {...args}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName) + "")}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Boolean",
        "Error",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorBoolean
                    sx={{ width: "200px" }}
                    {...args2}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName) + "")}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Boolean",
        "Validation Provider",
    ),
];
